import { PersonOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import AgentRoleRow from './agentRoleRow';
import Loader from 'components/v2/common/loader';
import Result from 'components/v2/common/Result';

import { AgentRoles } from 'api/models/payload/AgentRoles';
import useTranslate from 'hooks/useTranslate';
import type { Agent } from 'types';

export interface AssignAgentSection {
    key: string;
    title: string;
    currentId?: number | null;
    agents: Agent[];
    role: AgentRoles;
}

interface AssignAgentsListProps {
    sections: AssignAgentSection[];
    hasApps: boolean;
    loading?: boolean;
    assigningRole?: AgentRoles | null;
    onAssign: (role: AgentRoles, agentId: number) => void | Promise<boolean>;
}

const AssignAgentsList = ({
    sections,
    hasApps,
    loading,
    assigningRole,
    onAssign,
}: AssignAgentsListProps) => {
    const { translate } = useTranslate();

    if (!hasApps) {
        return (
            <Result
                icon={<PersonOutlined sx={{ fontSize: 32 }} />}
                title={translate('selectAppFirst')}
                description={translate('selectAppFirstDescription')}
            />
        );
    }

    if (loading) {
        return <Loader message={translate('loading')} isCircular rootSx={{ py: 4 }} />;
    }

    if (!sections.length) {
        return (
            <Result
                icon={<PersonOutlined sx={{ fontSize: 32 }} />}
                title={translate('noAgentsAvailable')}
                description={translate('noAgentsAvailableDescription')}
            />
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            {sections.map((section) => (
                <AgentRoleRow
                    key={section.key}
                    label={section.title}
                    agents={section.agents}
                    currentId={section.currentId}
                    assigning={assigningRole === section.role}
                    onAssign={(agentId) => onAssign(section.role, agentId)}
                />
            ))}
        </Box>
    );
};

export default AssignAgentsList;
